var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex flex-grow",
      style: { width: _vm.width },
      attrs: { id: _vm.id }
    },
    [
      !_vm.horizontal && _vm.defaultWidth
        ? _c("div", { staticClass: "relative flex" }, [
            _c(
              "div",
              { style: { width: _vm.yAxesWidth + "px" } },
              [
                _c("BarChart", {
                  key: "y-axes-chart",
                  style: { height: _vm.height },
                  attrs: {
                    options: _vm.yAxesOptions,
                    "chart-data": _vm.chartCollection
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "relative overflow-x-auto scrollbar-lg",
                style: {
                  maxWidth:
                    "calc(" +
                    _vm.defaultWidth +
                    "px - " +
                    _vm.yAxesWidth +
                    "px)"
                },
                attrs: { id: "scrollable-" + _vm.id }
              },
              [
                _c("BarChart", {
                  key: "analytics-bar-chart",
                  staticClass: "relative z-10",
                  style: {
                    height: _vm.height,
                    width:
                      "calc(" +
                      _vm.widthChart +
                      "px - " +
                      _vm.yAxesWidth +
                      "px)"
                  },
                  attrs: {
                    options: _vm.chartOptions,
                    "chart-data": _vm.chartCollection
                  }
                }),
                _vm._v(" "),
                _vm.percentages.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "absolute bottom-12 flex items-center justify-between",
                        style: {
                          width:
                            "calc(" +
                            _vm.widthChart +
                            "px - " +
                            _vm.yAxesWidth +
                            "px)"
                        }
                      },
                      [
                        _c("div", { staticClass: "h-1 w-6.5 flex-shrink-0" }),
                        _vm._v(" "),
                        _vm._l(_vm.percentages, function(percentage, idx) {
                          return _c(
                            "div",
                            {
                              key: idx,
                              staticClass:
                                "w-13 flex items-center justify-center flex-shrink-0 bg-slate-300 rounded-full"
                            },
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-slate-800",
                                attrs: { text: percentage + "%" }
                              })
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "h-1 w-6.5 flex-shrink-0" })
                      ],
                      2
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.horizontal
        ? _c("HorizontalBarChart", {
            key: "analytics-horizontal-bar-chart",
            style: { height: _vm.height, width: _vm.width },
            attrs: {
              options: _vm.chartOptions,
              "chart-data": _vm.chartCollection
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a1b29a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a1b29a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analytics/graphs/BarChart.vue
// module id = null
// module chunks = 